export namespace Maintenance {

  export enum MaintenanceType {
    ReorganizeIndex = 0,
    RebuildIndex = 1,
    Cleanup = 2,
  }

  export enum MaintenanceStatus {
    Started = 0,
    Completed = 1,
    InProgress = 2,
    Warning = 3,
    Error = 4,
  }

  export class FragmentationProgress {
    type: MaintenanceType;
    status: MaintenanceStatus;
    progress: number;
    totalIndex: number;
    currentIndex: number;
    currentTable: string;
    currentIndexName: string;
    message: string;
    durationSeconds: number;
    fragmentationBefore: number;
    fragmentationAfter: number;
    improvement: number;
    timestamp: Date;

    constructor(data?: Partial<FragmentationProgress>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class CleanupProgress {
    type: MaintenanceType = MaintenanceType.Cleanup;
    status: MaintenanceStatus;
    message: string;
    cutoffUtc: string;
    batchSize: number;
    buckets: CleanupBucket[];
    currentTable?: CleanupTable;
    progress: number;
    timestamp: Date;
    totalDeleted: number;

    constructor(data?: Partial<CleanupProgress>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export enum CleanupTable {
    AccessHistory = 0,
    TagPropertyHistory = 1,
    AutoHistory = 2
  }

  export class CleanupBucket {
    table: CleanupTable;
    deleted: number;
    progress: number = 0;
    notes?: string;

    constructor(data?: Partial<CleanupBucket>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class SqlServerMetrics {
    cpuUsagePercentage: number;
    cpuCount: number;
    totalPhysicalMemoryMB: number;
    availablePhysicalMemoryMB: number;
    sqlServerMemoryUsageMB: number;
    pendingQueries: number;
    activeConnections: number;
    timestamp: Date;

    constructor(data?: Partial<SqlServerMetrics>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }


  export class IndexInfo {
    tableName: string;
    indexName: string;
    recordCount: number;
    fragmentation: number;

    constructor(data?: Partial<IndexInfo>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class DatabaseHealthScore {
    healthScore: number;
    indexes: IndexInfo[];
    timestamp: Date;

    constructor(data?: Partial<DatabaseHealthScore>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class IndexFragmentationReport {
    index: number;
    tableName: string;
    indexName: string;
    recordCount: number;
    fragmentationBefore: number;
    fragmentationAfter: number;
    improvement: number;
    durationSeconds: number;
    operationType: string;
    timestamp: Date;

    constructor(data?: Partial<IndexFragmentationReport>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }


}
